import { render, staticRenderFns } from "./EditAbout.vue?vue&type=template&id=d89a7754"
import script from "./EditAbout.vue?vue&type=script&lang=js"
export * from "./EditAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports